export const templateSuggestion = () => {

  const apply = $('#cross_sell_cart').length === 1;
  jQuery('body').addClass('es-suggestion-page');

  if (apply){
      
    const mobile = () => {
      const rowAddToCart = jQuery('.row.add-to-cart-confirmation.text-center>.col-xs-12');
      const image = jQuery('.atcc__image .col-xs-12').clone();
      const messageIcon = jQuery('.atcc__message .icon.icon-ok-roll').clone();
      const messageText = jQuery('.atcc__message .col-xs-12').text();
      const subtotal = jQuery('.atcc__subtotal .col-xs-12').clone();
      const subtotalInnerHTML = subtotal.get(0).innerHTML;
      const subtotalInnerHTMLReplaced = subtotalInnerHTML.replace('Subtotal de la cesta de la compra', 'Subtotal cesta');
          
      //generateHTML
      rowAddToCart.get(0).classList.add('rmc-flex-align-center');
      rowAddToCart.get(0).classList.add('rmc-pb-20');
      rowAddToCart.empty();
  
      //modify margin top
      jQuery('#main-container').get(0).classList.add('rmc-margin-top-18');
  
      //add image
      image.get(0).classList.add('atcc__image');
      image.get(0).classList.replace('col-xs-12', 'col-xs-3');
      rowAddToCart.append(image);
  
      //add texts
      const divTexts ='<div class="col-xs-9"><div class="row rmc-flex-align-center"><div class="atcc__messageIcon col-xs-1"></div><div class="atcc__messageText col-xs-11"></div></div><div class="row"><div class="atcc__subtotalIcon col-xs-1"></div><div class="atcc__subtotalText col-xs-11"></div></div></div>';
      const divTextsHtml = $.parseHTML(divTexts); 
      rowAddToCart.append(divTextsHtml);
  
      jQuery('.atcc__messageIcon').append(messageIcon);
      jQuery('.atcc__messageText').text(messageText);
      jQuery('.atcc__subtotalText').get(0).innerHTML = subtotalInnerHTMLReplaced;
  
      const buttons = jQuery('.atcc__buttons').clone();
      buttons.removeClass('atcc__buttons');
      buttons.removeClass('row');
      buttons.addClass('buttons_mobile');
      buttons.addClass('container-fluid');
      buttons.addClass('rmc-display-flex');
      jQuery('.atcc__buttons').empty();
      jQuery('.atcc__buttons').append(buttons);
  
      const buttonsChildrens = buttons.children();
      if (buttonsChildrens.length >= 2) {
        const gotoShoppingCart = buttonsChildrens.get(0);
        gotoShoppingCart.classList.replace('col-xs-12', 'container-fluid');
        gotoShoppingCart.classList.remove('col-sm-6');
        gotoShoppingCart.classList.remove('col-sm-push-6');
        gotoShoppingCart.classList.add('rmc-pl-12');
        gotoShoppingCart.classList.add('rmc-flex-grow-1');
          
        const gotoContinueShopping = buttonsChildrens.get(1);
        gotoContinueShopping.classList.replace('col-xs-12', 'container-fluid');
        gotoContinueShopping.classList.remove('col-sm-6');
        gotoContinueShopping.classList.remove('col-sm-pull-6');
        gotoContinueShopping.classList.add('rmc-flex-grow-100');
        gotoContinueShopping.classList.add('rmc-pr-12');
  
        buttons.prepend(buttonsChildrens.get(1));
          
        const shoppingCartImage = '<div class="m-cart-area-trigger-inner" data-tid="mini-cart-button" data-tracking-cart="1|24.99"><svg width="24" height="32" viewBox="0 0 32 30" class="dkt-svg-icon"><path d="M7.873 6.008A1.01 1.01 0 0 1 8 6h21a1 1 0 0 1 1 1v11a1 1 0 0 1-.836.986l-18 3a1 1 0 0 1-1.128-.72L5.318 4.281l-2.002.668a1 1 0 0 1-.632-1.898l3-1a1 1 0 0 1 1.28.681l.91 3.276zM8.427 8l3.296 11.864L28 17.153V8H8.427zM16 29a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm9 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" fill="#323233" fill-rule="evenodd"></path></svg></div>';
        const buttonLinks = jQuery('.atcc__buttons a');
        jQuery.each(buttonLinks, (i, v) => {
          v.classList.add('cta-v2--s');
        });
          
        buttonLinks.get(1).innerHTML = shoppingCartImage;
        buttonLinks.get(1).classList.add('buttons_cart');
          
        buttonLinks.get(0).innerHTML = 'Seguir comprando';
        buttonLinks.get(0).classList.add('cta-v2--2nd-important');
        buttonLinks.get(0).classList.add('rmc-fs-14');
  
        buttonLinks.get(0).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'carrito';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
  
        buttonLinks.get(1).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'seguir_comprando';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
          
      }
    };
  
    const web = () => {
      const rowAddToCart = jQuery('.row.add-to-cart-confirmation.text-center>.col-xs-12');
      const image = jQuery('.atcc__image .col-xs-12').clone();
      const messageIcon = jQuery('.atcc__message .icon.icon-ok-roll').clone();
      const messageText = jQuery('.atcc__message .col-xs-12').text();
      const subtotal = jQuery('.atcc__subtotal .col-xs-12').clone();
      const subtotalInnerHTML = subtotal.get(0).innerHTML;
      const subtotalInnerHTMLReplaced = subtotalInnerHTML.replace('Subtotal de la cesta de la compra', 'Subtotal cesta');
        
      //generateHTML
      //add texts
      const divContainer ='<div class="container-fluid max-width"></div>';
      const divContainerHtml = $.parseHTML(divContainer); 
      jQuery('.row.add-to-cart-confirmation.text-center').append(divContainerHtml);
        
      jQuery('.row.add-to-cart-confirmation.text-center .container-fluid').append(rowAddToCart);
        
      rowAddToCart.get(0).classList.remove('col-xs-12');
      rowAddToCart.get(0).classList.add('row');
      rowAddToCart.get(0).classList.add('rmc-flex-align-center');
      rowAddToCart.empty();
        
      //add image
      image.get(0).classList.add('atcc__image');
      image.get(0).classList.remove('col-xs-12');
      image.get(0).classList.add('col-xs-2');
      rowAddToCart.append(image);
        
      //add texts
      const divTexts ='<div class="col-xs-5"><div class="row rmc-flex-align-center"><div class="atcc__messageIcon col-xs-2 rmc-flex-align-center"></div><div class="col-xs-10"><div class="row atcc__messageText"></div><div class="row atcc__subtotalText"/></div></div></div>';
      const divTextsHtml = $.parseHTML(divTexts); 
      rowAddToCart.append(divTextsHtml);
        
      jQuery('.atcc__messageIcon').append(messageIcon);
      jQuery('.atcc__messageText').text(messageText);
      jQuery('.atcc__subtotalText').get(0).innerHTML = subtotalInnerHTMLReplaced;
        
      //add buttons
      const divButtons ='<div class="col-xs-5 rmc-product-buttons"></div>';
      const divButtonsHtml = $.parseHTML(divButtons); 
      rowAddToCart.append(divButtonsHtml);
        
      const buttons = jQuery('.atcc__buttons').clone();
      jQuery('.rmc-product-buttons').append(buttons);
        
      const buttonsChildrens = buttons.children();
      if (buttonsChildrens.length >= 2) {
        const buttonLinks = jQuery('.atcc__buttons a');
        buttonLinks.get(0).innerHTML = 'Ir a la cesta';
        buttonLinks.get(0).classList.add('text-left');
        buttonLinks.get(0).classList.add('rmc-ma-auto');
          
        buttonLinks.get(1).innerHTML = 'Seguir comprando';
        buttonLinks.get(1).classList.add('text-right');
        buttonLinks.get(1).classList.add('rmc-ma-auto');
          
        buttonLinks.get(0).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'carrito';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
          
        buttonLinks.get(1).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'seguir_comprando';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
          
        buttons.children().get(0).classList.remove('col-sm-6');
        buttons.children().get(0).classList.add('col-sm-5');
        buttons.children().get(0).classList.remove('col-sm-push-6');
        buttons.children().get(0).classList.add('col-sm-push-7');
        buttons.children().get(0).classList.remove('text-left');
        buttons.children().get(0).classList.add('rmc-pl-12');
          
        buttons.children().get(1).classList.remove('col-sm-6');
        buttons.children().get(1).classList.add('col-sm-7');
        buttons.children().get(1).classList.remove('col-sm-pull-6');
        buttons.children().get(1).classList.add('col-sm-pull-5');
        buttons.children().get(1).classList.remove('text-right');
        buttons.children().get(1).classList.add('rmc-flex-justify-end');
        buttons.children().get(1).classList.add('rmc-pr-12');
          
      }
        
      buttons.get(0).classList.add('rmc-flex-align-center');
      jQuery('.row.atcc__buttons').get(1).remove();
    };
  
    const tabletPortrait = () => {
      const bigScreen = (window.screen.width >= 1024);
      $('#main-container').addClass('portrait');
      $('#main-container').removeClass('landscape');
  
      const rowAddToCart = jQuery('.row.add-to-cart-confirmation.text-center>.col-xs-12');
      const image = jQuery('.atcc__image .col-xs-12').clone();
      const messageIcon = jQuery('.atcc__message .icon.icon-ok-roll').clone();
      const messageText = jQuery('.atcc__message .col-xs-12').text();
      const subtotal = jQuery('.atcc__subtotal .col-xs-12').clone();
      const subtotalInnerHTML = subtotal.get(0).innerHTML;
      const subtotalInnerHTMLReplaced = subtotalInnerHTML.replace('Subtotal de la cesta de la compra', 'Subtotal cesta');
          
      //modify margin top
      jQuery('#main-container').get(0).classList.add('rmc-margin-top-24');
  
      //generateHTML
      //add texts
      const divContainer ='<div class="container-fluid max-width"></div>';
      const divContainerHtml = $.parseHTML(divContainer); 
      jQuery('.row.add-to-cart-confirmation.text-center').append(divContainerHtml);
  
      jQuery('.row.add-to-cart-confirmation.text-center .container-fluid').append(rowAddToCart);
  
      rowAddToCart.get(0).classList.remove('col-xs-12');
      rowAddToCart.get(0).classList.add('row');
      rowAddToCart.get(0).classList.add('rmc-flex-align-center');
      rowAddToCart.empty();
  
      //add image
      image.get(0).classList.add('atcc__image');
      image.get(0).classList.add('rmc-product-image');
      image.get(0).classList.replace('col-xs-12', 'col-xs-3');
      rowAddToCart.append(image);
  
      //add texts
      const divTexts ='<div class="col-xs-12 rmc-product-text rmc-pb-20"><div class="row rmc-flex-align-center"><div class="atcc__messageIcon col-xs-2 rmc-flex-align-center"></div><div class="col-xs-10"><div class="row atcc__messageText"></div><div class="row atcc__subtotalText"/></div></div></div>';
      const divTextsHtml = $.parseHTML(divTexts); 
      rowAddToCart.append(divTextsHtml);
  
      jQuery('.atcc__messageIcon').append(messageIcon);
      jQuery('.atcc__messageText').text(messageText);
      jQuery('.atcc__subtotalText').get(0).innerHTML = subtotalInnerHTMLReplaced;
  
      //add buttons
      const divButtons ='<div class="col-xs-12 rmc-product-buttons"></div>';
      const divButtonsHtml = $.parseHTML(divButtons); 
      rowAddToCart.append(divButtonsHtml);
  
      const buttons = jQuery('.atcc__buttons').clone();
      jQuery('.rmc-product-buttons').append(buttons);
  
      const buttonsChildrens = buttons.children();
      if (buttonsChildrens.length >= 2) {
        const buttonLinks = jQuery('.atcc__buttons a');
        buttonLinks.get(0).innerHTML = 'Ir a la cesta';
        buttonLinks.get(0).classList.add('text-left');
        buttonLinks.get(0).classList.add('rmc-ma-auto');
          
          
        buttonLinks.get(1).innerHTML = 'Seguir comprando';
        buttonLinks.get(1).classList.add('text-right');
        buttonLinks.get(1).classList.add('rmc-ma-auto');
          
        if (bigScreen){
          buttonLinks.get(0).classList.add('rmc-mw-300');
          buttonLinks.get(1).classList.add('rmc-mw-300');
        }
  
          
        buttonLinks.get(0).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'carrito';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
  
        buttonLinks.get(1).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'seguir_comprando';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
          
        buttons.children().get(0).classList.replace('col-xs-12', 'col-xs-6');
        buttons.children().get(0).classList.add('col-xs-push-6');
        buttons.children().get(0).classList.remove('text-left');
        buttons.children().get(0).classList.add('rmc-pl-12');
          
        buttons.children().get(1).classList.replace('col-xs-12', 'col-xs-6');
        buttons.children().get(1).classList.add('col-xs-pull-6');
        buttons.children().get(1).classList.remove('text-right');
        buttons.children().get(1).classList.add('rmc-flex-justify-end');
        buttons.children().get(1).classList.add('rmc-pr-12');
  
      }
        
      buttons.get(0).classList.add('rmc-flex-align-center');
      jQuery('.row.atcc__buttons').get(1).remove();
  
      const divTextAndButtonContainer ='<div class="rmc-product-container col-xs-9"></div>';
      const divTextAndButtonContainerHtml = $.parseHTML(divTextAndButtonContainer); 
      $('.our-suggestions__top .container-fluid > .rmc-flex-align-center').append(divTextAndButtonContainerHtml);
        
      $('.our-suggestions__top .container-fluid .rmc-product-container').append($('.rmc-product-text'));
      $('.our-suggestions__top .container-fluid .rmc-product-container').append($('.rmc-product-buttons'));
  
    };
  
    const tabletLandscape = () => {
      $('#main-container').addClass('landscape');
      $('#main-container').removeClass('portrait');
  
      const rowAddToCart = jQuery('.row.add-to-cart-confirmation.text-center>.col-xs-12');
      const image = jQuery('.atcc__image .col-xs-12').clone();
      const messageIcon = jQuery('.atcc__message .icon.icon-ok-roll').clone();
      const messageText = jQuery('.atcc__message .col-xs-12').text();
      const subtotal = jQuery('.atcc__subtotal .col-xs-12').clone();
      const subtotalInnerHTML = subtotal.get(0).innerHTML;
      const subtotalInnerHTMLReplaced = subtotalInnerHTML.replace('Subtotal de la cesta de la compra', 'Subtotal cesta');
          
      //generateHTML
      //add texts
      const divContainer ='<div class="container-fluid max-width"></div>';
      const divContainerHtml = $.parseHTML(divContainer); 
      jQuery('.row.add-to-cart-confirmation.text-center').append(divContainerHtml);
  
      jQuery('.row.add-to-cart-confirmation.text-center .container-fluid').append(rowAddToCart);
  
      rowAddToCart.get(0).classList.remove('col-xs-12');
      rowAddToCart.get(0).classList.add('row');
      rowAddToCart.get(0).classList.add('rmc-flex-align-center');
      rowAddToCart.empty();
  
      //add image
      image.get(0).classList.add('atcc__image');
      image.get(0).classList.replace('col-xs-12', 'col-xs-2');
      image.get(0).classList.add('rmc-product-image');
      rowAddToCart.append(image);
  
      //add texts
      const divTexts ='<div class="col-xs-5 rmc-product-text"><div class="row rmc-flex-align-center"><div class="atcc__messageIcon col-xs-2 rmc-flex-align-center"></div><div class="col-xs-10"><div class="row atcc__messageText"></div><div class="row atcc__subtotalText"/></div></div></div>';
      const divTextsHtml = $.parseHTML(divTexts); 
      rowAddToCart.append(divTextsHtml);
  
      jQuery('.atcc__messageIcon').append(messageIcon);
      jQuery('.atcc__messageText').text(messageText);
      jQuery('.atcc__subtotalText').get(0).innerHTML = subtotalInnerHTMLReplaced;
  
      //add buttons
      const divButtons ='<div class="col-xs-5 rmc-product-buttons"></div>';
      const divButtonsHtml = $.parseHTML(divButtons); 
      rowAddToCart.append(divButtonsHtml);
  
      const buttons = jQuery('.atcc__buttons').clone();
      jQuery('.rmc-product-buttons').append(buttons);
  
      const buttonsChildrens = buttons.children();
      if (buttonsChildrens.length >= 2) {
        const buttonLinks = jQuery('.atcc__buttons a');
        buttonLinks.get(0).innerHTML = 'Ir a la cesta';
        buttonLinks.get(0).classList.add('text-left');
        buttonLinks.get(0).classList.add('rmc-ma-auto');
          
          
        buttonLinks.get(1).innerHTML = 'Seguir comprando';
        buttonLinks.get(1).classList.add('text-right');
        buttonLinks.get(1).classList.add('rmc-ma-auto');
          
        buttonLinks.get(0).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'carrito';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
  
        buttonLinks.get(1).on('click', () => {
          const typeLabel = '';
          const category = 'middle_cart';
          const action = 'seguir_comprando';
          cube.analytics.sendEvent(jQuery(this), 'NavigationEvent', category, action, typeLabel, '');
        });
          
        // buttons.children().get(0).classList.replace('col-sm-6', 'col-sm-5');
        // buttons.children().get(0).classList.replace('col-sm-push-6', 'col-sm-push-7');
        buttons.children().get(0).classList.remove('text-left');
        buttons.children().get(0).classList.add('rmc-pl-12');
          
        // buttons.children().get(1).classList.replace('col-sm-6', 'col-sm-7');
        // buttons.children().get(1).classList.replace('col-sm-pull-6', 'col-sm-pull-5');
        buttons.children().get(1).classList.remove('text-right');
        buttons.children().get(1).classList.add('rmc-flex-justify-end');
        buttons.children().get(1).classList.add('rmc-pr-12');
  
      }
        
      buttons.get(0).classList.add('rmc-flex-align-center');
      jQuery('.row.atcc__buttons').get(1).remove();
        
    };
  
      
    const MOBILE = 'mobile';
    const DESKTOP = 'desktop';
    const TABLET = 'tablet';
      
      
    if (window.tc_vars.env_channel === MOBILE) {
      $('#main-container').addClass('mobile');
      mobile();
    }else if (window.tc_vars.env_channel === DESKTOP) {
      $('#main-container').addClass('desktop');
      web();
    }else if (window.tc_vars.env_channel === TABLET) {
      $('#main-container').addClass('tablet');
      // tablet();
        
      const defaultMain = $('#main-container').get(0).innerHTML;
        
      // Listen for orientation changes
      window.addEventListener('orientationchange', () => {
      // Announce the new orientation number
        $('#main-container').get(0).innerHTML = defaultMain;
        const isPortrait = window.screen.orientation.type.indexOf('portrait') > -1;
        if (isPortrait){
          tabletPortrait();
        }else{
          tabletLandscape();
        }
      }, false);
        
      const isPortrait = window.screen.orientation.type.indexOf('portrait') > -1;
      if (isPortrait){
        tabletPortrait();
      }else{
        tabletLandscape();
      }
        
    }else{
      web();
    }

    cube.lazyload.init();

  }
};


  


// WEBPACK FOOTER //
// ./src/_override/shared/suggestion-template/suggestion-template.js